import styles from "./CardAngka.module.css"
import { Card } from "antd"
import CountUp from 'react-countup'

const CardAngka = (props) => {

  const { angka, deskripsi } = props
  return (
    <>
      <Card
        className={styles.CardAngka}
        bodyStyle={{ padding: "16px" }}
        variant="borderless"
        data-aos="fade-up">
        <h1 className={styles.angka}>
          <CountUp end={angka} duration={2.5} />
          ++
        </h1>
        <p className={styles.deskripsi}>{deskripsi}</p>
      </Card>
    </>
  )
}
export default CardAngka